import { Box, IconButton, Paper, Tooltip, Typography } from "@mui/material";

/**
 * Peças do padrão visual da tela de Usuários (lista e Cadastrar/Editar), para as outras telas
 * seguirem o mesmo desenho sem copiar o `sx` de lá:
 * - `CardSecao`: Paper com borda e cabeçalho `#fafafa` (ícone azul + título), como "Dados do Usuário";
 * - `RodapeFixo`: barra branca presa ao rodapé, com resumo (chips) à esquerda e ações à direita;
 * - `AcaoIcone`: botão de ícone da coluna Ações da lista, com tooltip e rótulo acessível.
 */

export function CardSecao({ icone, titulo, acao, children, sx, corpoSx }) {
  return (
    <Paper
      variant="outlined"
      sx={{
        mb: 2,
        borderRadius: 2,
        bgcolor: "#fff",
        border: "1px solid #e0e0e0",
        boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
        overflow: "hidden",
        ...sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          px: 2,
          py: 1.5,
          bgcolor: "#fafafa",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {icone && <Box sx={{ display: "flex", color: "#18316e", "& svg": { fontSize: 20 } }}>{icone}</Box>}
          <Typography variant="subtitle1" fontWeight={600} color="text.primary" component="h2">
            {titulo}
          </Typography>
        </Box>
        {acao}
      </Box>
      <Box sx={{ p: 2, ...corpoSx }}>{children}</Box>
    </Paper>
  );
}

export function RodapeFixo({ resumo, children }) {
  return (
    <Box
      sx={{
        position: "sticky",
        bottom: 0,
        left: 0,
        right: 0,
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        py: 2,
        px: 3,
        bgcolor: "#fff",
        border: "1px solid #e8e8e8",
        borderRadius: "12px",
        boxShadow: "0 -2px 8px rgba(0,0,0,0.06)",
      }}
    >
      <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 2 }}>{resumo}</Box>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>{children}</Box>
    </Box>
  );
}

const TONS_ACAO = {
  azul: { bgcolor: "#e3f2fd", color: "#1565c0" },
  vermelho: { bgcolor: "#ffebee", color: "#c62828" },
  verde: { bgcolor: "#e8f5e9", color: "#2e7d32" },
};

export function AcaoIcone({ titulo, onClick, children, tom = "azul", disabled = false }) {
  return (
    <Tooltip title={titulo}>
      <span>
        <IconButton
          size="small"
          aria-label={titulo}
          onClick={onClick}
          disabled={disabled}
          sx={{ color: "#616161", "&:hover": TONS_ACAO[tom] || TONS_ACAO.azul }}
        >
          {children}
        </IconButton>
      </span>
    </Tooltip>
  );
}
